// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__1bTj3","body":"Home_body__3bTqO","content":"Home_content__sgIvw"};